var AuthenticateTokenController = /** @class */ (function () {
    /*@ngInject*/
    function AuthenticateTokenController($timeout, authService, MESSAGECONSTANTS) {
        this.$timeout = $timeout;
        this.authService = authService;
        this.MESSAGECONSTANTS = MESSAGECONSTANTS;
    }
    AuthenticateTokenController.prototype.$onInit = function () {
        var _this = this;
        //variables
        this.tokenObject = {};
        this.tokenObject.token = this.token;
        this.tokenObject.email = this.email;
        if (this.companyId) {
            this.tokenObject.companyId = this.companyId;
        }
        //flags
        this.loadingFlag = true;
        this.$timeout(function () {
            if (_this.email !== undefined) {
                _this.authenticateToken();
            }
        }, 500);
    };
    AuthenticateTokenController.prototype.authenticateToken = function () {
        var _this = this;
        if (!this.authenticateForm.$invalid) {
            this.authService.authenticateToken(this.tokenObject, function (data) {
                if (_this.successCallback) {
                    _this.successCallback({ tokenResponse: data });
                }
            }, function (error) {
                if (_this.errorCallback) {
                    _this.errorCallback({ tokenResponse: error });
                }
            });
        }
    };
    return AuthenticateTokenController;
}());
AuthenticateTokenController.$inject = ['$timeout', 'authService', 'MESSAGECONSTANTS'];
// import * as TEMPLATE from './authenticate-token.html';
import * as TEMPLATE from 'raw-loader!./authenticate-token.html';
export var AuthenticateTokenComponent = {
    selector: 'authenticateToken',
    component: {
        bindings: {
            token: '@',
            email: '@',
            companyId: '@',
            successCallback: '&',
            errorCallback: '&'
        },
        controller: AuthenticateTokenController,
        // templateUrl: 'app/partials/tokenLogin/authenticateToken/authenticate-token.html'
        template: TEMPLATE.default
    }
};
//# sourceMappingURL=authenticate-token.component.js.map